module.exports = __webpack_public_path__ + "static/media/Story-Ideation-1.94f99851.jpg";